import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/warehouse/control',
}).lazy(() => import('./control.lazy').then((d) => d.Route))
